import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { AscDatePickerPopoverValue } from "../AscDatePickerPopover/AscDatePickerPopover";
dayjs.extend(customParseFormat);

const DATE_FORMAT = "DD/MM/YYYY";
const DATE_REGEX = /([0-3][0-9][/])([0-1][0-9][/])([1-3][0-9][0-9][0-9])/g;

export function transformInputStringToDatePickerPopoverValue(
  inputValue: string,
  range: boolean
): { value?: AscDatePickerPopoverValue; error?: string } {
  const dates = inputValue?.match(DATE_REGEX);

  const startDate = dayjs(dates?.[0], "DD/MM/YYYY", true);
  if (!startDate?.isValid()) {
    return { error: "Invalid Start Date" };
  }

  if (!range) {
    return {
      value: {
        startDate: startDate?.toDate(),
        endDate: null,
      },
    };
  }
  const endDate = dayjs(dates?.[1], "DD/MM/YYYY", true);

  if (startDate.isAfter(endDate)) {
    return { error: "Invalid Date Range" };
  }

  if (!endDate?.isValid()) {
    return { error: "Invalid End Date" };
  }

  return {
    value: {
      startDate: startDate?.toDate(),
      endDate: endDate?.toDate(),
    },
  };
}

export function formatDateToInputString(
  _datePickerValue?: AscDatePickerPopoverValue
): string {
  if (_datePickerValue?.startDate && _datePickerValue?.endDate) {
    return `${dayjs(_datePickerValue?.startDate).format(DATE_FORMAT)} - ${dayjs(
      _datePickerValue?.endDate
    ).format(DATE_FORMAT)}`;
  }
  if (_datePickerValue?.startDate) {
    return dayjs(_datePickerValue?.startDate).format(DATE_FORMAT);
  }
  return "";
}
